import { useEffect } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { gsap } from "gsap";

type BlackFridayDecorationProps = {
  smallSize?: boolean;
};

export function BlackFridayDecoration({
  smallSize,
}: BlackFridayDecorationProps) {
  useEffect(() => {
    const images = document.querySelectorAll(".blackFriday img");
    const notStarIndices = [4, 5, 9, 10, 15];

    const starImages: Element[] = [];
    const notStarImages: Element[] = [];

    images.forEach((img, index) => {
      if (notStarIndices.includes(index)) {
        notStarImages.push(img);
      } else {
        starImages.push(img);
      }
    });

    notStarImages.forEach((img, index) => {
      gsap.fromTo(
        img,
        { scale: 0 },
        {
          duration: 2,
          delay: index * 0.1,
          scale: 1,
          rotate: 0,
          ease: "back.out(1.2)",
        },
      );
    });

    starImages.forEach((img, index) => {
      gsap.to(img, {
        duration: 3,
        delay: index * 0.08,
        scale: 1,
        ease: "bounce.inOut",
      });
    });
  }, []);

  return smallSize ? (
    <div className='blackFriday relative mx-auto mb-2 h-[66px] w-[270px] overflow-hidden bg-black will-change-transform'>
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-3 scale-0'
        width='7'
        height='7'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-2 left-6 scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='blackFriday-animate absolute bottom-5 left-[36px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='blackFriday-animate absolute top-3 left-8 scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/label-purple.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-8 scale-0'
        width='18'
        height='18'
      />
      <img
        src='/static/i/black-friday/label-yellow.svg'
        alt='black-friday-decoration'
        className='left-10 absolute top-2 scale-0'
        width='26'
        height='26'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[90px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-3 left-[100px] scale-0'
        width='7'
        height='7'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-0 left-[108px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/img/plus.svg'
        alt='black-friday-decoration'
        className='absolute top-3 left-[120px] scale-0'
        width='30'
        height='30'
      />
      <img
        src='/static/img/plus.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[143px] scale-0'
        width='15'
        height='15'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-3 left-[152px] scale-0'
        width='7'
        height='7'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-4 left-[162px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-1 left-[176px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-2 left-[184px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/label-indigo-right.svg'
        alt='black-friday-decoration'
        className='absolute top-0 left-[184px] scale-0'
        width='46'
        height='60'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[223px] scale-0'
        width='4'
        height='4'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-2 left-[238px] scale-0'
        width='7'
        height='7'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-3 left-[251px] scale-0'
        width='4'
        height='4'
      />
    </div>
  ) : (
    <div className='blackFriday relative mb-3 h-[100px] bg-black will-change-transform md:mb-4'>
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-4 scale-0'
        width='10'
        height='10'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-2 left-8 scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-8 left-[55px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-5 left-[90px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/label-purple.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[80px] scale-0'
        width='28'
        height='28'
      />
      <img
        src='/static/i/black-friday/label-yellow.svg'
        alt='black-friday-decoration'
        className='absolute top-2 left-[110px] scale-0'
        width='40'
        height='40'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[136px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-4 left-[155px] scale-0'
        width='10'
        height='10'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-0 left-[162px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/img/plus.svg'
        // src='/static/i/black-friday/plus.svg'
        alt='black-friday-decoration'
        className='absolute top-5 left-[181px] scale-0'
        width='45'
        height='45'
      />
      <img
        src='/static/img/plus.svg'
        // src='/static/i/black-friday/plus.svg'
        alt='black-friday-decoration'
        className='absolute bottom-3 left-[215px] scale-0'
        width='22'
        height='22'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-4 left-[230px] scale-0'
        width='10'
        height='10'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-6 left-[260px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-1 left-[282px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-3 left-[302px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/label-indigo-right.svg'
        alt='black-friday-decoration'
        className='absolute top-0 left-[300px] rotate-[50deg] scale-0'
        width='65'
        height='90'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute bottom-2 left-[362px] scale-0'
        width='5'
        height='5'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-3 left-[380px] scale-0'
        width='10'
        height='10'
      />
      <img
        src='/static/i/black-friday/white-star.svg'
        alt='black-friday-decoration'
        className='absolute top-4 left-[422px] scale-0'
        width='5'
        height='5'
      />
    </div>
  );
}
